import type { TOC } from '@ember/component/template-only';
import { PrismIcon } from '@mylighthouse/prism-ember';

interface HotelPricingAssistantOverrideIndicatorSignature {
  Args: {
    isDisabled?: boolean;
  };
}

const HotelPricingAssistantOverrideIndicator: TOC<HotelPricingAssistantOverrideIndicatorSignature> =
  <template>
    <PrismIcon
      @color={{if @isDisabled "disabled" "info"}}
      @name="bullet"
      @size="small"
      data-test-id="override-icon"
    />
  </template>;

export default HotelPricingAssistantOverrideIndicator;
